<template>
  <div>
    <tito-question
      v-for="(question, index) in questions"
      :key="question.id"
      :question="question"
      :locale="locale"
      :errors="errors"
      :ticket="ticket"
      v-model="answers[question.id]"
      @input="emitAnswers"
    ></tito-question>
  </div>
</template>

<script>
import TitoQuestion from "../Question.vue";
import Vue from "vue";

export default {
  components: { TitoQuestion },

  props: ["locale", "ticket", "chosenActivityIds", "questions", "errors"],

  data() {
    let answers = {};
    let ticket = this.ticket;
    (this.ticket.possible_questions || []).forEach(function (question) {
      answers[question.id] =
        ticket.answers.find((answer) => answer.question_id === question.id) ||
        {};
    });
    return {
      answers: answers,
    };
  },

  created() {
    this.emitAnswers();
  },

  computed: {
    answersWithoutFiles() {
      const filteredAnswers = {};
      Object.keys(this.answers).forEach((questionId) => {
        const question = this.questions.find((q) => q.id == questionId);
        if (question && question.field_type !== "File") {
          filteredAnswers[questionId] = this.answers[questionId];
        }
      });
      return filteredAnswers;
    },
  },

  methods: {
    emitAnswers() {
      this.$emit("input", Object.values(this.answersWithoutFiles));
    },
  },
};
</script>
